module.exports = __webpack_public_path__ + "media/images/static/entry/help_icon-e5790b19b9f20f4617bd3296c2c274d2.png";